import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import CanonicalEnforcer from "./components/seo/CanonicalEnforcer";
import Index from "./pages/Index";
import Domain from "./pages/Domain";
import BdixWebHosting from "./pages/WebHosting";
import BdixTurboHosting from "./pages/TurboHosting";
import ManagedVPS from "./pages/ManagedVPS";
import UnmanagedVPS from "./pages/UnmanagedVPS";
import DedicatedServer from "./pages/DedicatedServer";
import ResellerHosting from "./pages/ResellerHosting";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import RequiredDocuments from "./pages/RequiredDocuments";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <CanonicalEnforcer />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/domain" element={<Domain />} />
          <Route path="/bdix-web-hosting" element={<BdixWebHosting />} />
          <Route path="/bdix-turbo-hosting" element={<BdixTurboHosting />} />
          <Route path="/bdix-vps" element={<UnmanagedVPS />} />
          <Route path="/bdix-managed-vps" element={<ManagedVPS />} />
          <Route path="/bdix-dedicated-server" element={<DedicatedServer />} />
          <Route path="/bdix-reseller-hosting" element={<ResellerHosting />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/required-documents" element={<RequiredDocuments />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
